import { useQuery } from "@tanstack/react-query";
import { getAuth } from "api/login";

export const useFetchAuth = () => {
  return useQuery(["auth"], getAuth);
};
